import Cookies from 'js-cookie'

const SESSION_ABSOLUTE_MS = 30 * 24 * 60 * 60 * 1000
const MIN_COOKIE_MAX_AGE_SECONDS = 60

function cookieMaxAgeSeconds(sessionStartedAtMs?: number): number {
  if (!sessionStartedAtMs) {
    return SESSION_ABSOLUTE_MS / 1000
  }
  const remainingMs = sessionStartedAtMs + SESSION_ABSOLUTE_MS - Date.now()
  const remainingSeconds = Math.floor(remainingMs / 1000)
  return Math.max(remainingSeconds, MIN_COOKIE_MAX_AGE_SECONDS)
}

export function setAuthCookie(value: string, sessionStartedAtMs?: number) {
  const maxAge = cookieMaxAgeSeconds(sessionStartedAtMs)
  Cookies.set('auth', value, {
    path: '/',
    expires: maxAge / (60 * 60 * 24),
    sameSite: 'lax',
  })
}

export function getAuthCookie(): string | undefined {
  return Cookies.get('auth')
}

export function removeAuthCookie() {
  Cookies.remove('auth', { path: '/' })
}
